// "New this week in the library" strip: admin-published via /admin → Library digest, falls back to sample badges.
import { useEffect, useState } from "react";
import { getLibraryDigest } from "@/lib/api";
import { LIBRARY_ITEMS, LIBRARY_VERSION } from "@/lib/hs-library-sample";

export const weekLabel = (d = new Date()) => {
  const m = new Date(d);
  m.setDate(m.getDate() - ((m.getDay() + 6) % 7));
  return `Week of ${m.toLocaleDateString("en-GB", { day: "numeric", month: "long" })}`;
};

export const SAMPLE_DIGEST_ITEMS = LIBRARY_ITEMS.filter((i) => i.badge).slice(0, 8).map((i) => ({ title: i.title, cat: i.cat, kind: i.badge.toLowerCase(), trade: i.trade, note: "" }));
export const DEFAULT_INTRO = "Fresh from Fixlr's H&S team — UK-law-accurate, versioned, and one click from your workspace.";

export const resolveDigest = (d) => {
  if (!d?.configured) return { configured: false, visible: true, week_label: weekLabel(), intro: DEFAULT_INTRO, version: LIBRARY_VERSION, items: SAMPLE_DIGEST_ITEMS };
  return { ...d, week_label: d.week_label || weekLabel(), intro: d.intro || DEFAULT_INTRO, version: d.version || LIBRARY_VERSION, items: d.items || [] };
};

let cache = null;
export const invalidateDigest = () => { cache = null; };

export const useLibraryDigest = () => {
  const [raw, setRaw] = useState(cache);
  useEffect(() => {
    let on = true;
    (cache ? Promise.resolve(cache) : getLibraryDigest().then((d) => (cache = d)).catch(() => (cache = {}))).then((d) => on && setRaw(d));
    return () => { on = false; };
  }, []);
  return { digest: resolveDigest(raw), loaded: !!raw };
};
